export { NavigationService } from 'sce-core';
// #TODO-LIBRARY NavigationService Used in 185 places in 83 files WMS /src/app.. should be re-referenced from library directly



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/core/navigation.service.ts